var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-y-auto flex flex-col flex-1"},[_c('div',{staticClass:"overflow-y-auto"},[_c('panel-header',{attrs:{"title":_vm.title,"align":_vm.isFullHeight ? 'left' : 'center'}}),_vm._t("default")],2),_vm._t("actions")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }